import {useQuery} from 'react-query';
import {getPostDetail} from 'services/postDetail';

const useGetPostDetail = (guid: string) => {
  const {data, isLoading} = useQuery(['post-detail', guid], getPostDetail);
  return {productDetail: data, isLoading};
};

export default useGetPostDetail;
